export default "__VITE_ASSET__Cz1e5r4v__"